<template>
<div v-if="bookingsDataSource.length > 0">
  <div v-if="showTittle" class="flex justify-center">
    <div class="flex flex-col items-start font-montserrat">
      <div class="flex">{{ $t('do_you_prefer_to_set_up_your_own_match') }}</div>
      <div class="flex text-sm text-gray-500">{{ $t('play_your_way') }}</div>
    </div>
  </div>
  <div class="mt-4 flex flex-col justify-center">
    <div
        v-for="book, in bookingsDataSource"
        :key="book.tenant.id"
        >
        <div class="flex items-center justify-center m-auto">
            <MatchBookingAvailability 
            :book="book"
            :date="filteredDataToSend.date"
            :allowShowMore="allowShowMore"
            @hourSelected="hourSelected"
            />
        </div>
    </div>
    <div v-if="showCreateMatch" class="flex items-center justify-center m-auto mb-4">
      <div class="rounded-xl shadow-md myMatchesClue w-[580px] sm:w-[320px] flex flex-col gap-4">
        <div class="w-full !border my-2 rounded-full border-gray-500"></div>
        <div>
          {{ $t("do_you_have_a_court") }}
        </div>
        <button
          @click="createMatchNotInTaykus"
          class="walletButton p-2 md:min-w-[364px] mx-auto"
        >
          {{ $t("i_allready_have_a_court") }}
        </button>
      </div>
    </div>
  </div>
</div>
<div v-else>
  <div v-if="showNoResults" class="mt-8 flex justify-center">
    {{ $t('no_results')}}
  </div>
</div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import MatchBookingAvailability from "@/components/match/MatchBookingAvailability.vue";
import { BookingHelper } from '@/helpers/bookingHelper';
import { Category, Purpose } from '@/enum/constants';
import { Format } from '@/helpers/formatHelper';

export default defineComponent({
    name: "MatchSuggestions",
    emits: ["hourSelected", "showErrorMessage"],
    components: {
      MatchBookingAvailability,
    },
    props: {
      filteredDataToSend: {
        type: Object,
        required: true,
      },
      showTittle: {
        type: Boolean,
        required: false,
        default: false
      },
      showNoResults: {
        type: Boolean,
        required: false,
        default: false
      },
      showCreateMatch: {
        type: Boolean,
        required: false,
        default: false
      },
      allowShowMore: {
        type: Boolean,
        required: false,
        default: true 
      }
    },
    watch: {
        filteredDataToSend: {
            async handler(newVal, oldVal) {
                if (newVal && Object.entries(newVal).length > 0) {
                    await this.loadBookings();
                }
            },
            deep: true,
            immediate: true, // execute on component mount
        }
    },
    data() {
        return {
            bookingsDataSource: [] as any[],
        };
    },
    methods: {
        async loadBookings() {
            ((this as any).$store).commit("setLoading", true)
            let dataToSend = JSON.parse(JSON.stringify(this.filteredDataToSend)) // clone prop filteredDataToSend
            dataToSend.category = Category.BOOKING //always bookings for disponibility
            dataToSend.purpose = Purpose.MATCH //always MATCH for disponibility
            if (dataToSend.tenantIds && typeof dataToSend.tenantIds === 'string') {//if tenantId is a string, put in array
              dataToSend.tenantIds = [dataToSend.tenantIds];
            }
            const message = await BookingHelper.messageAvailability(dataToSend);
            ((this as any).$store).commit("setLoading", false)
            const responseSearchItems = message.bookings;
            // filter tenants wiht times 0
            if(responseSearchItems){
              const filteredSearchItems = (responseSearchItems as any[]).filter(tenant => tenant.hours && tenant.hours.length > 0)
              this.bookingsDataSource = filteredSearchItems as [];
              if(!Format.IsNull(this.bookingsDataSource)){
                return this.$emit("showErrorMessage", false)
              }
              this.$emit("showErrorMessage", true)
            }
        },
        hourSelected(data:any) {
          this.$emit("hourSelected", data);
        },
        createMatchNotInTaykus() {
          const createMatchQuery = {
              name: "createMatch",
              query: {
                date: this.filteredDataToSend.date,
                cordX: this.filteredDataToSend.cordX,
                cordY: this.filteredDataToSend.cordY,
                sport: this.filteredDataToSend.sport,
                locName: this.filteredDataToSend.locName,
              },
          };
        return this.$router.push(createMatchQuery);
      },
    }
});
</script>
<style scoped>
.createMatch {
  background: rgb(9, 9, 121);
  background: linear-gradient(90deg, var(--color1) 35%, var(--color2) 100%);
  text-align: center;
}
</style>